export default ['$sce',
  function TrustedFilter ($sce) {
    return function(url) {
      return $sce.trustAsResourceUrl(url);
    };
  }
];



// WEBPACK FOOTER //
// ./source/client/filters/trusted.js